import React, { useEffect, useState } from 'react'
import { Box, CircularProgress, Typography, useTheme } from '@mui/material'
import { Navigate, useParams } from 'react-router-dom'
import { useUserStore } from '../../state'
import { useCoupon } from '../../hooks/useCoupon'
import { doGet } from "../../util/do-fetch"
import { createCheckoutSession } from "../../util/mini"

const BuyPackageScreen = () => {
	const theme = useTheme()
	const { user, authLoaded } = useUserStore()
	const coupon = useCoupon()
	const { categoryToken, packageToken, optionId } = useParams()
	const [error, setError] = useState(null)

	useEffect(() => {
		if (!authLoaded || !user) return
		if (!categoryToken || !packageToken || !optionId) return

		const controller = new AbortController()

		const startCheckout = async () => {
			try {
				const response = await doGet(
					`/mini/shop/${categoryToken}/${packageToken}`,
					{ signal: controller.signal }
				)
				const pkg = await response.json()
				const opt = pkg?.options?.find(o => o.id === optionId)
				if (!pkg || !opt) {
					setError('Package or option not found.')
					return
				}
				const cancelUrl = `${window.location.origin}/buy/${categoryToken}/${packageToken}/${optionId}`
				const url = await createCheckoutSession(
					pkg,
					opt,
					null,
					coupon && coupon.code,
					cancelUrl
				)
				window.location.href = url
			} catch (err) {
				if (err.name !== 'AbortError') {
					console.error('Checkout error', err)
					setError('Something went wrong. Please try again.')
				}
			}
		}

		startCheckout()
		return () => controller.abort()
	}, [authLoaded, user, categoryToken, packageToken, optionId])

	if (authLoaded && !user) {
		return <Navigate to={`/login?next=/buy/${categoryToken}/${packageToken}/${optionId}`} replace />
	}

	return (
		<Box
			display="flex"
			minWidth="100vw"
			minHeight="calc(100vh - 80px)"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			bgcolor={theme.palette.background.paper}
		>
			{error
				? <Typography color="error">{error}</Typography>
				: <CircularProgress />
			}
		</Box>
	)
}

export default BuyPackageScreen
